/*
 * @Description: 国际化-英文，此处导入并统一导出所有页面或组件的国际化文件配置，多层json结构防止冲突并使结构更清晰
 * @Author: 刘宝顺
 * @Date: 2023-09-25 11:37:40
 * @LastEditTime: 2024-02-01 14:27:29
 * @LastEditors: 刘宝顺
 */

import commonI18n from './common/en-US.json';
import downloadI18n from '@/pages/download/local/en-US.json';

const enUS = {
    common: commonI18n,
    pages: { download: downloadI18n },
    components: {},
};

export default enUS;
